// src/utils/auth.js
import { getCurrentLanguage } from "./userPreferences";

export function getStoredToken() {
  return localStorage.getItem("mercadito_token");
}

export function safeDecodeJwtPayload(token) {
  try {
    if (!token) return null;
    const payloadB64 = token.split(".")[1];
    if (!payloadB64) return null;
    return JSON.parse(atob(payloadB64));
  } catch {
    return null;
  }
}

export function clearAuthSession() {
  // 1. Remove the token
  localStorage.removeItem("mercadito_token");
  
  // 2. (Optional) Clear any other user-specific data if you have it
  // localStorage.removeItem("mercadito_lang"); 

  // 3. Redirect the user back to the login page
  window.location.href = "/login";
}

export function hasValidPlatformAccess(client = {}) {
  // 1. Give Platform Admins universal access immediately
  const session = getAuthSession();
  if (session.isAdmin) return true;

  // 2. Otherwise, enforce standard subscription rules
  if (!client) return false;

  if (client.subscription_status === "active") return true;

  if (
    client.subscription_status === "trialing" &&
    client.active_ends_at &&
    new Date(client.active_ends_at) > new Date()
  ) {
    return true;
  }

  if (
    client.subscription_status === "canceled" &&
    client.active_ends_at &&
    new Date(client.active_ends_at) > new Date()
  ) {
    return true;
  }

  return false;
}

export function getAuthSession() {
  const token = getStoredToken();
  const user = safeDecodeJwtPayload(token);

  const role = user?.role || null;
  const clientId = user?.client_id || null;

  return {
    token,
    user,
    role,
    clientId,
    language: getCurrentLanguage(),
    isAuthenticated: !!token && !!user,
    isAdmin: role === "admin",
    isClientAdmin: role === "client-admin",
    isClientOper: role === "client-oper"
  };
}